import { getPathString } from '@helpers'
import { TIME_LINE_MODE } from '@constants'
import { TimeLineDTOType } from '@types'

export const getFilterParamForObjectX = ({
  config,
  objectYKeyFieldsValues,
  startDate,
  endDate,
  commandParamsFilter,
  saRSQLFilter,
}: {
  config: TimeLineDTOType
  objectYKeyFieldsValues: unknown[]
  startDate?: string | null
  endDate?: string | null
  saRSQLFilter: string | null
  commandParamsFilter?: string
}): string => {
  const linkToObjectYPath = getPathString(config.objectX.linkToObjectY)

  const filters = []

  // Экранируем кавычки в значениях (если это строки)
  const escapedKeyFieldValues = objectYKeyFieldsValues
    .map(keyFieldValue => `"${keyFieldValue}"`)
    .join(',')
  const objectYKeyFieldValuesFilter = escapedKeyFieldValues?.length
    ? `${linkToObjectYPath}=in=(${escapedKeyFieldValues})`
    : ''

  if (objectYKeyFieldValuesFilter) {
    filters.push(objectYKeyFieldValuesFilter)
  }

  if (commandParamsFilter) {
    filters.push(commandParamsFilter)
  }

  if (saRSQLFilter) {
    filters.push(saRSQLFilter)
  }

  if (config.mode === TIME_LINE_MODE.DATE_TIME) {
    // Формируем фильтр данных объекта согласно временному интервалу, в фильтре учитывается только дата начала
    const timeIntervalFilter = `${config.objectX.startDateField}=ge="${startDate}";${config.objectX.startDateField}=lt="${endDate}"`

    filters.push(timeIntervalFilter)
  }

  // Объединяем условия через AND (;)
  return filters.join(';')
}
